import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=a649fab0&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"
import style0 from "./Select2.vue?vue&type=style&index=0&id=a649fab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a649fab0",
  null
  
)

export default component.exports